/**
 * DTF Product — fiche produit ISD (rebrush mono, lot 4)
 * Vanilla JS, amélioration progressive.
 *
 * 1. Galerie : les vignettes remplacent le média principal.
 * 2. Délai atelier : Standard / Rush 48 h / Rush 24 h.
 *    Le délai est une option, pas un produit visible : les fiches
 *    « Rush » restent des produits Shopify cachés. Au moment de
 *    l'ajout au panier, on aligne le panier sur le choix du client
 *    (retrait des lignes de service qui ne correspondent pas, ajout
 *    du Rush choisi avec la propriété _cart_service), PUIS on laisse
 *    partir la soumission normale — que ce soit l'app
 *    isd-dtf-factory-app (qui intercepte le submit du formulaire et
 *    pousse ses visuels) ou le formulaire natif.
 *    Sans JS : les radios partent en propriété de ligne, rien ne casse.
 */
(function () {
  'use strict';

  /* ------------------------------------------------------------
     Galerie
     ------------------------------------------------------------ */
  function initGallery(section) {
    var main = section.querySelector('.dtf-product__gallery-main');
    var thumbs = section.querySelectorAll('.dtf-product__thumb');
    if (!main || thumbs.length === 0) return;

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var mediaType = thumb.dataset.mediaType;
        var mediaId = thumb.dataset.mediaId;

        thumbs.forEach(function (t) {
          t.classList.remove('dtf-product__thumb--active');
        });
        thumb.classList.add('dtf-product__thumb--active');

        var newEl;
        if (mediaType === 'video') {
          newEl = document.createElement('video');
          newEl.className = 'dtf-product__main-image dtf-product__main-video';
          newEl.controls = true;
          newEl.playsInline = true;
          newEl.preload = 'metadata';
          newEl.poster = thumb.dataset.mediaPoster || '';
          var sources = [];
          try { sources = JSON.parse(thumb.dataset.mediaSources || '[]'); } catch (e) {}
          sources.forEach(function (s) {
            var source = document.createElement('source');
            source.src = s.url;
            source.type = s.mime_type;
            newEl.appendChild(source);
          });
        } else if (mediaType === 'external_video') {
          newEl = document.createElement('iframe');
          newEl.className = 'dtf-product__main-image dtf-product__main-iframe';
          newEl.src = thumb.dataset.mediaEmbed || '';
          newEl.setAttribute('frameborder', '0');
          newEl.setAttribute('allowfullscreen', '');
          newEl.loading = 'lazy';
        } else {
          newEl = document.createElement('img');
          newEl.className = 'dtf-product__main-image';
          newEl.src = thumb.dataset.mediaSrc || '';
          if (thumb.dataset.mediaSrcset) newEl.srcset = thumb.dataset.mediaSrcset;
          newEl.sizes = '(min-width: 990px) 50vw, 100vw';
          newEl.alt = thumb.dataset.mediaAlt || '';
          newEl.loading = 'eager';
        }
        newEl.setAttribute('data-media-id', mediaId);

        // On garde l'étiquette (badge) si elle existe.
        var badge = main.querySelector('.dtf-product__badge');
        main.innerHTML = '';
        if (badge) main.appendChild(badge);
        main.appendChild(newEl);
      });
    });
  }

  /* ------------------------------------------------------------
     Délai atelier
     Même mécanique que le sélecteur de la page panier
     (sections/main-cart-items.liquid) : la ligne « Rush » porte la
     propriété cachée _cart_service = handle du produit rush, plus une
     propriété visible « Délai atelier ». Le panier la reconnaît donc,
     l'affiche comme option et peut la retirer.
     ------------------------------------------------------------ */
  function initDelay(section) {
    var block = section.querySelector('[data-dtf-delay]');
    if (!block || !window.fetch) return;

    var form = section.querySelector('form[action*="/cart/add"]');
    var radios = Array.prototype.slice.call(block.querySelectorAll('input[type="radio"]'));
    var status = block.querySelector('[data-dtf-delay-status]');
    var rushRadios = radios.filter(function (r) { return r.dataset.variantId && r.dataset.service; });
    if (rushRadios.length === 0) return;

    var routes = window.routes || {};
    var cartUrl = (routes.cart_url || '/cart') + '.js';
    var cartAddUrl = (routes.cart_add_url || '/cart/add') + '.js';
    var cartChangeUrl = (routes.cart_change_url || '/cart/change') + '.js';
    var jsonHeaders = { 'Content-Type': 'application/json', Accept: 'application/json' };

    function setStatus(text) {
      if (status) status.textContent = text || '';
    }

    function fetchCart() {
      return fetch(cartUrl, { headers: { Accept: 'application/json' }, cache: 'no-store' })
        .then(function (r) { return r.ok ? r.json() : null; });
    }

    function serviceLines(cart) {
      return (cart && cart.items ? cart.items : []).filter(function (item) {
        return item && item.properties && item.properties._cart_service;
      });
    }

    // Pré-sélection : si un Rush est déjà au panier, on le reflète.
    fetchCart()
      .then(function (cart) {
        var lines = serviceLines(cart);
        if (!lines.length) return;
        var current = lines[0].properties._cart_service;
        rushRadios.forEach(function (r) {
          if (r.dataset.service === current) r.checked = true;
        });
        setStatus('Déjà au panier pour cette commande.');
      })
      .catch(function () {});

    radios.forEach(function (r) {
      r.addEventListener('change', function () { setStatus(''); });
    });

    if (!form) return;

    // Aligne le panier sur le choix : une seule ligne de service, ou aucune.
    function syncCart() {
      var checked = block.querySelector('input[type="radio"]:checked');
      var wanted = checked && checked.dataset.service ? checked : null;

      return fetchCart().then(function (cart) {
        var lines = serviceLines(cart);
        var chain = Promise.resolve();
        var alreadyThere = false;

        lines.forEach(function (line) {
          if (wanted && line.properties._cart_service === wanted.dataset.service && !alreadyThere) {
            alreadyThere = true;
            return;
          }
          chain = chain.then(function () {
            return fetch(cartChangeUrl, {
              method: 'POST',
              headers: jsonHeaders,
              body: JSON.stringify({ id: line.key, quantity: 0 })
            });
          });
        });

        if (wanted && !alreadyThere) {
          chain = chain.then(function () {
            var properties = { _cart_service: wanted.dataset.service };
            properties['Délai atelier'] = wanted.dataset.optionTitle || wanted.value;
            return fetch(cartAddUrl, {
              method: 'POST',
              headers: jsonHeaders,
              body: JSON.stringify({ items: [{ id: wanted.dataset.variantId, quantity: 1, properties: properties }] })
            }).then(function (r) {
              if (!r.ok) throw new Error('add failed');
            });
          });
        }

        return chain;
      });
    }

    // Phase de capture : on passe avant le runtime de l'app, qui
    // écoute le même submit en phase de bouillonnement.
    form.addEventListener('submit', function (event) {
      if (form.dataset.dtfDelaySynced === '1') {
        form.dataset.dtfDelaySynced = '';
        return; // deuxième passage : on laisse faire
      }

      event.preventDefault();
      event.stopImmediatePropagation();
      if (block.classList.contains('is-syncing')) return; // double clic
      block.classList.add('is-syncing');
      setStatus('');

      syncCart()
        .catch(function () {
          setStatus('Option de délai non appliquée — vérifiez-la au panier.');
        })
        .then(function () {
          block.classList.remove('is-syncing');
          form.dataset.dtfDelaySynced = '1';
          // Nouveau submit annulable : l'app (si présente) le prend en
          // charge ; sinon, soumission native.
          var again = new Event('submit', { bubbles: true, cancelable: true });
          var notPrevented = form.dispatchEvent(again);
          if (notPrevented) form.submit();
          form.dataset.dtfDelaySynced = '';
        });
    }, true);
  }

  /* ------------------------------------------------------------
     Init
     ------------------------------------------------------------ */
  function initSection(section) {
    initGallery(section);
    initDelay(section);
  }

  function init() {
    document.querySelectorAll('.dtf-product').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (e) {
      var section = e.target.querySelector('.dtf-product');
      if (section) initSection(section);
    });
  }
})();
